import { logoutUser } from "api/utils";
import { buildLoginUrl } from "pages/common/state/utils";

// Client side redirect to move to new login for reset password and welcome flows
(async function redirectToLoginFrontend() {
    if (typeof window === "undefined") {
        return;
    }
    const loginFrontendUrl = new URL(buildLoginUrl(window.location.hostname));
    const hashUrl = window.location.hash;

    // if {domain}/login.jsp?logout..., logout the user
    if (new URLSearchParams(window.location.search).get("logout") === "") {
        try {
            await logoutUser();
        } catch (error) {
            // API 401s if already logged out
        }
    }

    if (!hashUrl) {
        (window as Window).location = loginFrontendUrl.toString();
        return;
    }

    const parametersString = hashUrl.startsWith("#")
        ? hashUrl.replace("#", "")
        : hashUrl;

    const parameters = parametersString.split("/").filter(Boolean);

    const [flow, ...otherParams] = parameters;

    if (flow.endsWith("welcome")) {
        // Welcome:
        // #/welcome/{userId}/{tokenId}/{email} => {loginFrontend}/?welcome={userId}/{tokenId}/{email}
        loginFrontendUrl.searchParams.append("welcome", otherParams.join("/"));
    }

    if (flow.endsWith("reset-password-token")) {
        // Reset password:
        // #/reset-password-token/{token} => {loginFrontend}/reset-password?token={token}
        loginFrontendUrl.pathname = "/reset-password";
        loginFrontendUrl.searchParams.append("token", otherParams[0]);
    }

    (window as Window).location = loginFrontendUrl.toString();
})();

const LoginPage = () => {
    return null;
};

export default LoginPage;
